import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, distinctUntilChanged, of, switchMap } from 'rxjs';
import { AlertComponent } from 'src/app/alert/alert.component';
import { DataServiceService } from 'src/app/data-service.service';

@Component({
  selector: 'app-collect-school-details',
  templateUrl: './collect-school-details.component.html',
  styleUrls: ['./collect-school-details.component.scss']
})
export class CollectSchoolDetailsComponent implements OnInit {

  searchCtrl = new FormControl('');
  schools: any[] = [];
  district: any;
  selectedSchool: any;
  studentName:any;
  admNo: any;

  constructor(private dataService: DataServiceService, private route: ActivatedRoute, private dailog: MatDialog) { }

  ngOnInit(): void {
this.route.paramMap.subscribe(params => {
      this.admNo = params.get('uniref')!;
      this.studentName = params.get('studentName')!;
    });
    this.searchCtrl.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        switchMap((value: any) =>
          value && value.length > 2
            ? this.dataService.searchStudents(value)
            : of([])
        )
      )
      .subscribe(data => {
        this.schools = data;
      });
  }

  getSchoolDetails(school: any) {
    console.log(school)
    this.district = school.districtName
    this.selectedSchool = school
  }

  saveSchoolDetails() {
    const payload = {
      schoolId: this.selectedSchool.schoolId,
      schoolName: this.selectedSchool.schoolName,
      admNo: this.admNo
    }
    this.dataService.saveSchoolDetails(payload).subscribe({
      next: (res: any) => {
        console.log(res)
        this.dailog.open(AlertComponent, {
          width: '400px',
          height: '60px',
          position: { top: '10px', right: '10px' },
          data: {
            data: res.message,
            status: "Success"

          }
        })

      },
      error: (err: any) => {
        console.log(err)
        this.dailog.open(AlertComponent, {
          width: '400px',
          height: '60px',
          position: { top: '10px', right: '10px' },
          data: {
            data: err.message,
            status: "Warning"

          }
        })
      }
    })
  }
}